import React from 'react';
import schoolIphone from '../../assets/images/app-screenshots/school-management-iphone.png';
import schoolPupils from '../../assets/images/app-screenshots/school-pupils.png';

function TrafficHomeOne({ className }) {
    return (
        <section className={`dd-traffic-area pt-140 pb-180 ${className || ''}`} id="school">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7">
                        <div className="dd-traffic-title">
                            <span>School Management</span>
                            <h3 className="title">For everyone who keeps your business running.</h3>
                            <p>
                                Delegate day-to-day management to other instructors or an administrator such as a family member.
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service mb-30">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-pencil" />
                                    </div>
                                    <h5 className="title">Plan lessons</h5>
                                    <p>Draft lessons for instructors to review and approve.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service item-2 mb-30">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-calendar" />
                                    </div>
                                    <h5 className="title">View diaries</h5>
                                    <p>See what’s booked in each instructor’s diary.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service item-3 mb-30">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-car" />
                                    </div>
                                    <h5 className="title">Travel clashes</h5>
                                    <p>Spot travel clashes when planning a draft lesson for another instructor.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service item-4 mb-30">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-arrow-right-arrow-left" />
                                    </div>
                                    <h5 className="title">Assign pupils</h5>
                                    <p>View pupil details and move pupils between instructors.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service item-5">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-clipboard" />
                                    </div>
                                    <h5 className="title">Activity log</h5>
                                    <p>See who did what across your school, from lessons to pupil changes.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="dd-traffic-service item-6">
                                    <div className="icon">
                                        <i className="fa-jelly-fill fa-regular fa-lock" />
                                    </div>
                                    <h5 className="title">Roles & access</h5>
                                    <p>Give admins and instructors the access they need, and keep billing to yourself.</p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <p className="dd-school-note">
                                    School mode switches on automatically as soon as there&apos;s more than
                                    one person in your school.
                                </p>
                            </div>
                            {/* Learn More hidden for now
                            <div className="col-lg-12">
                                <div className="traffic-btn mt-50">
                                    <a className="main-btn" href="#">
                                        Learn More <i className="fa-jelly-fill fa-regular fa-arrow-right" />
                                    </a>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div
                            className="dd-school-devices wow animated fadeInRight"
                            data-wow-duration="2000ms"
                            data-wow-delay="200ms"
                        >
                            <img
                                className="dd-school-iphone"
                                src={schoolPupils}
                                alt="Drive.Day on iPhone: the school pupil list, filtered by instructor"
                            />
                            <img
                                className="dd-school-iphone"
                                src={schoolIphone}
                                alt="Drive.Day on iPhone: the school diary showing one instructor"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TrafficHomeOne;
